/** Match backend selection of authored conditions; never infer recency from IDs. */
const fields = ['tenantId', 'questionaireId', 'sectionId', 'questionId', 'targetQuestionId',
  'targetSectionId', 'conditionOperator', 'value', 'translations'];
const stable = value => {
  if (Array.isArray(value)) return value.map(stable);
  if (value && typeof value === 'object') return Object.fromEntries(Object.keys(value).sort().map(k => [k, stable(value[k])]));
  return value ?? null;
};
function timestamp(value) {
  if (typeof value !== 'string') return null;
  const compact = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})$/.exec(value);
  if (compact) value = `${compact[1]}-${compact[2]}-${compact[3]}T${compact[4]}:${compact[5]}:${compact[6]}Z`;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?(Z|[+-]\d{2}:\d{2})?$/.test(value)) return null;
  if (!/(Z|[+-]\d{2}:\d{2})$/.test(value)) value += 'Z';
  const [hour, minute, second] = value.slice(11, 19).split(':').map(Number);
  if (hour > 23 || minute > 59 || second > 59) return null;
  const result = Date.parse(value);
  // Reject normalized invalid dates, just as Python's datetime parser does.
  const [year, month, day] = value.slice(0, 10).split('-').map(Number);
  if (year < 1 || month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate()) return null;
  return Number.isFinite(result) ? result : null;
}
export function selectCondition(records, enabled = true) {
  if (enabled !== true) return { condition: null };
  const rows = records.filter(r => r.status !== 'isDeleted' && r.op !== 'd');
  if (!rows.length) return { condition: null, error: 'missing_condition' };
  if (rows.length === 1) return { condition: rows[0] };
  const dates = rows.map(r => timestamp(r.updatedAt) ?? timestamp(r.createdAt));
  const candidates = dates.some(d => d === null) ? rows : rows.filter((r, i) => dates[i] === Math.max(...dates));
  const contracts = new Set(candidates.map(r => JSON.stringify(stable(Object.fromEntries(fields.map(k => [k, r[k]]))))));
  if (contracts.size > 1) return { condition: candidates[0], warning: 'ambiguous_condition_recency' };
  return { condition: [...candidates].sort((a, b) => String(a.id || '').localeCompare(String(b.id || '')))[0] };
}
